import Navbar from "../NavBar/Navbar"
import SideBar from "../NavBar/Sidebar"
import ContactanosContent from "./ContactanosContent"

interface ChildsProps {
    logout: () => void
}


const Contactanos: React.FC<ChildsProps> = ({ logout }) => {

    return (
        <div className="sidebar-noneoverflow">
            <Navbar logout={logout} />

            <div className="main-container" id="container">
                <SideBar />
                <ContactanosContent />
            </div>

        </div>
    )
}



export default Contactanos